import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const NewSubscriptionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const NewSubscriptionProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("subscriptions", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <NewSubscriptionContext.Provider value={contextValue}>
      {children}
    </NewSubscriptionContext.Provider>
  );
};

export default NewSubscriptionProvider;
